import { combineReducers } from 'redux'

import profile from './military/militaryProfile'

import * as profileActions from '../actions/military'
import { MILITARY_SEARCH, MOC_COMPARISON } from '../actions/military'
import * as h2Api from '../h2Api'

const initialState = {
  selected: [],
  error: null
}
const mocComparisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.MOC_COMPARISON_SET_ERROR:
      return {
        ...state,
        error: action.error
      }

    case profileActions.REMOVE_MOC_FOR_COMPARISON:
      return {
        ...state,
        selected: state.selected.filter(i => i !== action.id)
      }

    case profileActions.CLEAR_MOC_COMPARISON:
      return {
        ...state,
        selected: []
      }

    case profileActions.SELECT_MOC_FOR_COMPARISON:
      if (state.selected.indexOf(action.id) >= 0) {
        return state
      }

      return {
        ...state,
        selected: [...state.selected, action.id]
      }

    default:
      return state
  }
}
const military = combineReducers({
  profile,
  comparison: mocComparisonReducer,
  searchRequest: h2Api.restReducer(MILITARY_SEARCH),
  comparisonResponse: h2Api.restReducer(MOC_COMPARISON)
})

export default military
